// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset y configuración base - v2.1 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  /* Impide que el zoom de texto del sistema (accesibilidad Android/iOS)
     infle las unidades rem y distorsione el layout del juego.
     El fix nativo en MainActivity.java es la solución principal;
     esto actúa como salvaguarda adicional para PWA/navegador. */
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

html,
body {
  height: 100%;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow-x: hidden;
  -webkit-user-select: none;
  user-select: none;
}

/* Ajuste de escala para móviles en landscape (pantalla de juego, poco alto
   disponible). No se aplica en portrait: ahí sobra alto y esta reducción
   solo conseguía que todo el texto basado en rem (la mayoría del UI) se
   viera más pequeño de lo que ya estaban ajustados los breakpoints. */
@media (max-width: 600px) and (orientation: landscape) {
  html {
    font-size: 14px; /* Reducir tamaño base en móvil */
  }
}

/* En portrait hay mucho alto disponible respecto al ancho: subimos un poco
   la base para que todo el texto (que en su mayoría usa rem) se vea más
   grande sin tener que tocar cada componente individualmente. */
@media (orientation: portrait) {
  html {
    font-size: 18px;
  }
}

.app {
  height: 100dvh;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}

/* Header moderno y responsive */
.header {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 1rem;
  padding: 1rem;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 60px;
}

@media (max-width: 600px) {
  .header {
    padding: 0.5rem;
    margin-bottom: 1rem;
    min-height: 48px;
    border-radius: 0.75rem;
  }
}

.title {
  font-size: clamp(1.2rem, 4vw, 1.8rem);
  font-weight: bold;
  color: #1a1a1a;
  text-align: center;
  flex: 1;
  margin: 0;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

.about-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #667eea;
  color: white;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  text-decoration: none;
}

.about-button:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

/* Contenedor principal */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 500px;
  margin: 0 auto;
  width: 100%;
  padding: 0;
  min-height: 0;
}

@media (max-width: 600px) {
  .main-content {
    gap: 1rem;
    max-width: 100%;
  }
}

/* Cards de opciones */
.options-section {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1;
  min-height: 0;
  padding: 0.5rem 0;
}

.card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1rem;
  padding: 1.5rem 1rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 3px solid rgba(255, 255, 255, 0.3);
  min-height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

/* Contenedor para el contenido de la card */
.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/* Efecto de cards no seleccionadas cuando hay una seleccionada */
.options-section:has(.card-selected) .card:not(.card-selected):not(.card-inactive) {
  opacity: 0.6;
  filter: grayscale(20%);
  transition: all 0.3s ease;
}

.options-section:has(.card-selected) .card:not(.card-selected):not(.card-inactive):hover {
  opacity: 0.8;
  filter: grayscale(0%);
}

/* Fallback para navegadores sin soporte :has() */
@supports not (selector(:has(.card-selected))) {
  .card:not(.card-selected):not(.card-inactive) {
    opacity: 0.7;
  }

  .card:not(.card-selected):not(.card-inactive):hover {
    opacity: 1;
  }
}

.card:hover:not(.card-selected) {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  background: rgba(255, 255, 255, 1);
  border-color: rgba(102, 126, 234, 0.3);
}

.card-selected:hover {
  transform: scale(1.02) translateY(-2px);
  box-shadow:
    0 18px 60px rgba(102, 126, 234, 0.5),
    0 0 0 4px #667eea;
  background: #d6ecf0;
}

.card-selected {
  border-color: #667eea;
  background: #e8f4f8;
  box-shadow:
    0 15px 50px rgba(102, 126, 234, 0.4),
    0 0 0 3px #667eea;
  border-width: 4px;
  border-style: solid;
  transform: scale(1.02);
  position: relative;
}

.card-selected::after {
  content: 'check_circle';
  font-family: 'Material Icons';
  position: absolute;
  top: 8px;
  right: 8px;
  background: #63c08a;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  box-shadow:
    0 3px 12px rgba(46, 204, 113, 0.5),
    0 1px 3px rgba(0, 0, 0, 0.2);
  z-index: 5;
  animation: checkAppear 0.3s ease-out;
  border: 2px solid white;
}

@keyframes selectedPulse {

  0%,
  100% {
    opacity: 0.9;
  }

  50% {
    opacity: 1;
  }
}

@keyframes checkAppear {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.card img {
  width: 60px;
  height: 60px;
  margin-bottom: 0.75rem;
  object-fit: contain;
}

.card-title {
  font-size: clamp(0.9rem, 2.5vw, 1.1rem);
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 0.75rem;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
}

.card-description {
  font-size: clamp(0.75rem, 2vw, 0.9rem);
  color: #444;
  line-height: 1.5;
  font-weight: 500;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.6);
  transition: all 0.3s ease;
}

.card-selected .card-title {
  color: #2d3748;
  font-weight: 800;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

.card-selected .card-description {
  color: #4a5568;
  font-weight: 600;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.6);
}

/* Botón de inicio */
.start-section {
  flex-shrink: 0;
  padding: 1.5rem 0 2rem;
  background: linear-gradient(to top, rgba(102, 126, 234, 0.05), transparent);
  backdrop-filter: blur(10px);
}

.start-button {
  width: 100%;
  padding: 1.5rem 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 1rem;
  font-size: clamp(1.1rem, 3vw, 1.3rem);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.start-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.start-button:active {
  transform: translateY(0);
}

.start-button::before {
  content: 'play_arrow';
  font-family: 'Material Icons';
  font-size: 1.5em;
}

/* Fix CRÍTICO para orientación vertical - Forzar reset completo de estilos landscape */
@media (orientation: portrait) {
  .card {
    flex-direction: column !important;
    text-align: center !important;
    gap: 0 !important;
    min-height: 140px !important;
    padding: 1.5rem 1rem !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .card-content {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    text-align: center !important;
  }

  .card-title {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    text-align: center !important;
    margin-bottom: 0.75rem !important;
    font-size: clamp(0.9rem, 2.5vw, 1.1rem) !important;
    font-weight: 700 !important;
    color: #1a1a1a !important;
  }

  .card-description {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    text-align: center !important;
    line-height: 1.5 !important;
    font-size: clamp(0.75rem, 2vw, 0.9rem) !important;
    color: #444 !important;
    font-weight: 500 !important;
  }

  .card img {
    width: 60px !important;
    height: 60px !important;
    margin-bottom: 0.75rem !important;
    object-fit: contain !important;
  }

  /* Reset específico para móviles en portrait */
  @media (max-width: 480px) {
    .card {
      min-height: 120px !important;
      padding: 1.25rem 0.75rem !important;
    }

    .card img {
      width: 50px !important;
      height: 50px !important;
      margin-bottom: 0.5rem !important;
    }

    .card-title {
      margin-bottom: 0.5rem !important;
    }
  }

  @media (max-width: 360px) {
    .card {
      min-height: 100px !important;
      padding: 1rem 0.5rem !important;
    }

    .card img {
      width: 40px !important;
      height: 40px !important;
    }
  }
}

/* Responsive Design */
@media (max-width: 480px) {
  .app {
    padding: 1.5rem 0.75rem 0;
    height: 100dvh;
    overflow: hidden;
  }

  .header {
    padding: 0.75rem;
    margin-bottom: 1.5rem;
    flex-shrink: 0;
  }

  .main-content {
    gap: 1.5rem;
    padding: 0.75rem 0 0;
    flex: 1;
    min-height: 0;
  }

  .options-section {
    grid-template-columns: 1fr;
    gap: 1rem;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    padding: 0.5rem 0;
  }

  .card {
    padding: 1.25rem 0.75rem;
    min-height: 120px;
  }

  .card img {
    width: 50px;
    height: 50px;
    margin-bottom: 0.5rem;
  }

  .card-title {
    margin-bottom: 0.5rem;
  }

  .start-section {
    flex-shrink: 0;
    padding: 1rem 0 1.5rem;
    background: linear-gradient(to top, rgba(102, 126, 234, 0.05), transparent);
  }

  .start-button {
    padding: 1rem 0.75rem;
    min-height: 60px;
  }
}

@media (max-width: 360px) {
  .app {
    padding: 1rem 0.5rem 0;
  }

  .card {
    min-height: 100px;
    padding: 1rem 0.5rem;
  }

  .card img {
    width: 40px;
    height: 40px;
  }

  .start-section {
    padding: 0.75rem 0 1rem;
  }
}

/* Layout mejorado para orientación horizontal - Mantiene estructura familiar */
@media (max-height: 500px) and (orientation: landscape) {
  .app {
    padding: 0.5rem 1rem;
    flex-direction: column;
    gap: 0.75rem;
    height: 100dvh;
    overflow: hidden;
  }

  .header {
    padding: 0.5rem 1rem;
    min-height: 40px;
    margin-bottom: 0.75rem;
    flex-shrink: 0;
  }

  .title {
    font-size: clamp(1rem, 3vw, 1.3rem);
  }

  .about-button {
    width: 36px;
    height: 36px;
    font-size: 1rem;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    min-height: 0;
    overflow: hidden;
  }

  .options-section {
    flex: 1;
    position: relative;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    padding: 0.5rem;
    max-height: 100%;

    /* Barra de scroll más visible y atractiva */
    scrollbar-width: auto;
    scrollbar-color: rgba(102, 126, 234, 0.8) rgba(255, 255, 255, 0.1);
  }

  .card {
    min-height: 100px;
    padding: 1rem;
    flex-direction: row;
    text-align: left;
    gap: 1rem;
    transition: all 0.2s ease;
  }

  .card:hover:not(.card-selected) {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }

  .card img {
    width: 50px;
    height: 50px;
    margin-bottom: 0;
    flex-shrink: 0;
  }

  .card-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .card-title {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    line-height: 1.3;
  }

  .card-description {
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .start-section {
    flex-shrink: 0;
    padding: 1rem 0 0.5rem;
  }

  .start-button {
    width: 100%;
    min-height: 60px;
    padding: 1rem;
  }
}

/* Orientación horizontal para móviles pequeños - Layout horizontal compacto */
@media (max-height: 450px) and (orientation: landscape) {
  .app {
    padding: 0.25rem 0.5rem;
    gap: 0.5rem;
  }

  .header {
    padding: 0.25rem 0.75rem;
    min-height: 35px;
    margin-bottom: 0.5rem;
  }

  .title {
    font-size: clamp(0.9rem, 2.5vw, 1.1rem);
  }

  .about-button {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }

  .main-content {
    gap: 0.75rem;
  }

  .options-section {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 0.75rem;
    padding: 0.25rem;
  }

  /* Barra de scroll más prominente en pantallas pequeñas */
  .options-section::-webkit-scrollbar {
    width: 10px;
  }

  .options-section::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 5px;
    border: 2px solid rgba(255, 255, 255, 0.1);
  }

  .card {
    min-height: 80px;
    padding: 0.75rem;
    gap: 0.75rem;
  }

  .card img {
    width: 40px;
    height: 40px;
  }

  .card-title {
    font-size: 1rem;
    line-height: 1.2;
    margin-bottom: 0.25rem;
  }

  .card-description {
    font-size: 0.8rem;
    line-height: 1.3;
  }

  .start-section {
    padding: 0.75rem 0 0.5rem;
  }

  .start-button {
    min-height: 50px;
    font-size: 0.85rem;
    padding: 0.75rem 0.5rem;
  }
}

/* Estilos para cards inactivas - próximamente */
.card-inactive {
  opacity: 0.6;
  cursor: not-allowed;
  position: relative;
  background: rgba(220, 220, 220, 0.8) !important;
  border: 3px solid rgba(200, 200, 200, 0.3) !important;
  pointer-events: none;
}

.card-inactive:hover {
  transform: none;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  background: rgba(220, 220, 220, 0.8) !important;
}

.card-inactive .card-title {
  color: #666;
}

.card-inactive .card-description {
  color: #888;
}

.card-inactive::after {
  content: var(--coming-soon-text, 'Próximamente');
  position: absolute;
  top: 8px;
  right: 8px;
  background: #e53e3e;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  z-index: 2;
}

/* Ajustes para modo landscape */
@media (max-height: 500px) and (orientation: landscape) {
  .card-inactive::after {
    top: 4px;
    right: 4px;
    padding: 2px 6px;
    font-size: 0.6rem;
  }
}

@media (max-height: 450px) and (orientation: landscape) {
  .card-inactive::after {
    top: 2px;
    right: 2px;
    padding: 2px 4px;
    font-size: 0.55rem;
  }
}

/* Indicador de scroll */
.scroll-indicator {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(102, 126, 234, 0.9), transparent);
  padding: 1rem;
  text-align: center;
  z-index: 10;
  opacity: 1;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.scroll-indicator.hidden {
  opacity: 0;
}

.scroll-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  color: white;
  font-size: 0.85rem;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.scroll-hint .material-icons {
  font-size: 1.5rem;
  animation: bounce 2s infinite;
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-10px);
  }

  60% {
    transform: translateY(-5px);
  }
}

/* Ocultar indicador en escritorio */
@media (min-width: 769px) {
  .scroll-indicator {
    display: none;
  }
}

/* Ajustar indicador para móviles pequeños */
@media (max-width: 480px) {
  .scroll-indicator {
    padding: 0.75rem;
  }

  .scroll-hint {
    font-size: 0.75rem;
  }

  .scroll-hint .material-icons {
    font-size: 1.25rem;
  }

  /* Ajustes para cards seleccionadas en móvil */
  .card-selected::after {
    width: 24px;
    height: 24px;
    font-size: 16px;
    top: 6px;
    right: 6px;
  }

  .card-selected {
    border-width: 3px;
  }
}

/* Indicador de scroll específico para landscape - Posicionado dentro del área de scroll */
@media (orientation: landscape) {
  .scroll-indicator {
    position: absolute;
    bottom: 10px;
    right: 10px;
    left: auto;
    top: auto;
    transform: none;
    width: auto;
    background: rgba(102, 126, 234, 0.9);
    border-radius: 20px;
    padding: 0.5rem 0.75rem;
    z-index: 150;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  .scroll-hint {
    flex-direction: row;
    writing-mode: horizontal-tb;
    gap: 0.5rem;
    align-items: center;
  }

  .scroll-hint .material-icons {
    transform: none;
    font-size: 1.1rem;
    animation: bounce 2s infinite;
  }

  .scroll-hint span {
    font-size: 0.75rem;
    white-space: nowrap;
  }
}

@media (max-height: 450px) and (orientation: landscape) {
  .scroll-indicator {
    bottom: 5px;
    right: 5px;
    padding: 0.25rem 0.5rem;
  }

  .scroll-hint span {
    font-size: 0.7rem;
  }

  .scroll-hint .material-icons {
    font-size: 1rem;
  }
}

@media (max-width: 360px) {
  .scroll-indicator {
    padding: 0.5rem;
  }

  .scroll-hint {
    font-size: 0.7rem;
  }

  .scroll-hint .material-icons {
    font-size: 1rem;
  }

  /* Ajustes adicionales para pantallas muy pequeñas */
  .card-selected::after {
    width: 20px;
    height: 20px;
    font-size: 14px;
    top: 4px;
    right: 4px;
  }
}

/* Mejoras adicionales para modo landscape */
@media (orientation: landscape) {

  /* Hacer más visible el área de scroll */
  .options-section {
    border: 2px solid rgba(102, 126, 234, 0.1);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.02);
  }

  /* Hover mejorado para cards en landscape */
  .card:hover {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  /* Transiciones suaves para el cambio de orientación - Deshabilitadas durante cambios de orientación */
  .app,
  .main-content,
  .options-section,
  .card {
    transition: all 0.3s ease;
  }

  /* Asegurar que durante los cambios de orientación no haya transiciones que interfieran */
  @media (orientation: portrait) {

    .card,
    .card-content,
    .card-title,
    .card-description {
      transition: none !important;
    }
  }
}

/* Estilos para landscape en dispositivos táctiles */
@media (orientation: landscape) and (hover: none) {
  .card {
    /* Hacer las cards más grandes en dispositivos táctiles */
    min-height: 100px;
    padding: 1rem 0.75rem;
  }

  .card img {
    width: 50px;
    height: 50px;
  }

  .card-title {
    font-size: 1.1rem;
  }

  .card-description {
    font-size: 0.85rem;
  }

  /* Mejorar la experiencia táctil del scroll */
  .options-section {
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }
}

/* Para pantallas landscape muy anchas (tablets en horizontal) */
@media (min-width: 768px) and (orientation: landscape) {
  .main-content {
    max-width: 1200px;
    margin: 0 auto;
    gap: 2rem;
  }

  .options-section {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1rem;
  }

  .card {
    min-height: 110px;
    padding: 1rem;
  }

  .start-section {
    padding: 1.5rem 0 1rem;
  }

  .start-button {
    padding: 1.5rem 1rem;
  }
}

/* Reglas específicas para móviles en landscape */
@media (max-width: 767px) and (orientation: landscape) {

  /* Asegurar que el contenido no se desborde */
  body {
    overflow-x: hidden;
  }

  .app {
    min-height: 100dvh;
    max-width: 100vw;
  }

  /* Optimizar el espacio vertical limitado */
  .header {
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
  }
}

/* Para pantallas landscape muy bajas (menos de 400px de altura) - Botón horizontal */
@media (max-height: 400px) and (orientation: landscape) {
  .main-content {
    flex-direction: column;
    gap: 0.5rem;
  }

  .start-section {
    width: auto;
    flex-shrink: 0;
    padding: 0.5rem 0;
  }

  .start-button {
    width: 100%;
    height: 50px;
    max-height: 50px;
    min-height: 50px;
    flex-direction: row;
    font-size: 0.9rem;
    padding: 0.75rem 1rem;
    gap: 0.5rem;
  }
}

/* ==========================================
   ESTILOS PARA ENLACES DE DEBUG
   ========================================== */

.debug-links {
  position: relative;
}

.debug-dropdown {
  position: relative;
  display: inline-block;
}

.debug-toggle {
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  border: none;
  border-radius: 20px;
  color: white;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(238, 90, 36, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.debug-toggle:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(238, 90, 36, 0.4);
  background: linear-gradient(135deg, #ff5252, #d84315);
}

.debug-toggle:active {
  transform: translateY(0);
}

.debug-toggle .material-icons {
  font-size: 16px;
}

.debug-toggle span {
  font-size: 10px;
  font-weight: 700;
}

.debug-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  min-width: 180px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  margin-top: 5px;
}

.debug-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.debug-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  color: #333;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  border-radius: 8px;
  margin: 4px;
}

.debug-link:hover {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  transform: translateX(2px);
}

.debug-link .material-icons {
  font-size: 18px;
  opacity: 0.8;
}

.debug-link span {
  font-weight: 600;
}

/* Animación para el icono de debug */
@keyframes debug-pulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}

.debug-toggle:hover .material-icons {
  animation: debug-pulse 0.6s ease-in-out;
}

/* Responsive para debug */
@media (max-width: 480px) {
  .debug-toggle {
    padding: 6px 10px;
    font-size: 11px;
  }

  .debug-toggle .material-icons {
    font-size: 14px;
  }

  .debug-toggle span {
    display: none;
    /* Ocultar texto en móviles muy pequeños */
  }

  .debug-menu {
    min-width: 160px;
    right: -10px;
  }

  .debug-link {
    padding: 10px 14px;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;;;gEAG8D;EAC9D,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,4DAA4D;EAC5D,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;sEAGsE;AACtE;EACE;IACE,eAAe,EAAE,iCAAiC;EACpD;AACF;;AAEA;;gEAEgE;AAChE;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,UAAU;EACV,aAAa;AACf;;AAEA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,WAAW;EACX,2DAA2D;EAC3D,gBAAgB;EAChB,iCAAiC;EACjC,OAAO;EACP,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,iEAAiE;AACjE;EACE,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC;;qBAEmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qBAEmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;gCAE8B;EAC9B,UAAU;EACV,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;;EAEE;;IAEE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,sBAAsB;EACtB,2EAA2E;EAC3E,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,uFAAuF;AACvF;EACE;IACE,iCAAiC;IACjC,6BAA6B;IAC7B,iBAAiB;IACjB,4BAA4B;IAC5B,+BAA+B;IAC/B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,kCAAkC;IAClC,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,qBAAqB;IACrB,6BAA6B;IAC7B,iCAAiC;IACjC,kDAAkD;IAClD,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,qBAAqB;IACrB,6BAA6B;IAC7B,2BAA2B;IAC3B,iDAAiD;IACjD,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA,8CAA8C;EAC9C;IACE;MACE,4BAA4B;MAC5B,mCAAmC;IACrC;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,gCAAgC;IAClC;;IAEA;MACE,gCAAgC;IAClC;EACF;;EAEA;IACE;MACE,4BAA4B;MAC5B,+BAA+B;IACjC;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;IACzB;EACF;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,OAAO;IACP,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,iCAAiC;IACjC,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,2EAA2E;EAC7E;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,+EAA+E;AAC/E;EACE;IACE,oBAAoB;IACpB,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,kBAAkB;IAClB,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,uBAAuB;IACvB,eAAe;IACf,gBAAgB;;IAEhB,4CAA4C;IAC5C,qBAAqB;IACrB,kEAAkE;EACpE;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA,8EAA8E;AAC9E;EACE;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2DAA2D;IAC3D,YAAY;IACZ,gBAAgB;EAClB;;EAEA,yDAAyD;EACzD;IACE,WAAW;EACb;;EAEA;IACE,6DAA6D;IAC7D,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA,gDAAgD;AAChD;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,qDAAqD;EACrD,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE;IACE,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,0EAA0E;EAC1E,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,aAAa;EACf;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,8CAA8C;EAC9C;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,0FAA0F;AAC1F;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,SAAS;IACT,eAAe;IACf,WAAW;IACX,oCAAoC;IACpC,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,2BAA2B;IAC3B,mCAAmC;EACrC;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;IACX,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA,oDAAoD;EACpD;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA,4CAA4C;AAC5C;;EAEE,wCAAwC;EACxC;IACE,0CAA0C;IAC1C,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA,2CAA2C;EAC3C;IACE,kCAAkC;IAClC,0CAA0C;EAC5C;;EAEA,sGAAsG;EACtG;;;;IAIE,yBAAyB;EAC3B;;EAEA,yFAAyF;EACzF;;IAEE;;;;MAIE,2BAA2B;IAC7B;EACF;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,yDAAyD;IACzD,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,6CAA6C;EAC7C;IACE,iCAAiC;IACjC,4BAA4B;EAC9B;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,iBAAiB;IACjB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,iDAAiD;AACjD;;EAEE,6CAA6C;EAC7C;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,2BAA2B;IAC3B,mCAAmC;EACrC;AACF;;AAEA,qFAAqF;AACrF;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;;+CAE+C;;AAE/C;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,4CAA4C;EAC5C,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA,0BAA0B;AAC1B;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0CAA0C;EAC5C;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["/* Reset y configuración base - v2.1 */\r\n* {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nhtml {\r\n  /* Impide que el zoom de texto del sistema (accesibilidad Android/iOS)\r\n     infle las unidades rem y distorsione el layout del juego.\r\n     El fix nativo en MainActivity.java es la solución principal;\r\n     esto actúa como salvaguarda adicional para PWA/navegador. */\r\n  -webkit-text-size-adjust: 100%;\r\n  text-size-adjust: 100%;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  height: 100%;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  overflow-x: hidden;\r\n  -webkit-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n/* Ajuste de escala para móviles en landscape (pantalla de juego, poco alto\r\n   disponible). No se aplica en portrait: ahí sobra alto y esta reducción\r\n   solo conseguía que todo el texto basado en rem (la mayoría del UI) se\r\n   viera más pequeño de lo que ya estaban ajustados los breakpoints. */\r\n@media (max-width: 600px) and (orientation: landscape) {\r\n  html {\r\n    font-size: 14px; /* Reducir tamaño base en móvil */\r\n  }\r\n}\r\n\r\n/* En portrait hay mucho alto disponible respecto al ancho: subimos un poco\r\n   la base para que todo el texto (que en su mayoría usa rem) se vea más\r\n   grande sin tener que tocar cada componente individualmente. */\r\n@media (orientation: portrait) {\r\n  html {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n.app {\r\n  height: 100dvh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Header moderno y responsive */\r\n.header {\r\n  background: rgba(255, 255, 255, 0.98);\r\n  backdrop-filter: blur(20px);\r\n  border-radius: 1rem;\r\n  padding: 1rem;\r\n  margin-bottom: 2rem;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  min-height: 60px;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .header {\r\n    padding: 0.5rem;\r\n    margin-bottom: 1rem;\r\n    min-height: 48px;\r\n    border-radius: 0.75rem;\r\n  }\r\n}\r\n\r\n.title {\r\n  font-size: clamp(1.2rem, 4vw, 1.8rem);\r\n  font-weight: bold;\r\n  color: #1a1a1a;\r\n  text-align: center;\r\n  flex: 1;\r\n  margin: 0;\r\n  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.about-button {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  background: #667eea;\r\n  color: white;\r\n  border: none;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.3s ease;\r\n  text-decoration: none;\r\n}\r\n\r\n.about-button:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\r\n}\r\n\r\n/* Contenedor principal */\r\n.main-content {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n  max-width: 500px;\r\n  margin: 0 auto;\r\n  width: 100%;\r\n  padding: 0;\r\n  min-height: 0;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .main-content {\r\n    gap: 1rem;\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n/* Cards de opciones */\r\n.options-section {\r\n  display: grid;\r\n  gap: 1.5rem;\r\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n  overflow-y: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  flex: 1;\r\n  min-height: 0;\r\n  padding: 0.5rem 0;\r\n}\r\n\r\n.card {\r\n  background: rgba(255, 255, 255, 0.95);\r\n  backdrop-filter: blur(20px);\r\n  border-radius: 1rem;\r\n  padding: 1.5rem 1rem;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  border: 3px solid rgba(255, 255, 255, 0.3);\r\n  min-height: 140px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n  overflow: hidden;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n/* Contenedor para el contenido de la card */\r\n.card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n/* Efecto de cards no seleccionadas cuando hay una seleccionada */\r\n.options-section:has(.card-selected) .card:not(.card-selected):not(.card-inactive) {\r\n  opacity: 0.6;\r\n  filter: grayscale(20%);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.options-section:has(.card-selected) .card:not(.card-selected):not(.card-inactive):hover {\r\n  opacity: 0.8;\r\n  filter: grayscale(0%);\r\n}\r\n\r\n/* Fallback para navegadores sin soporte :has() */\r\n@supports not (selector(:has(.card-selected))) {\r\n  .card:not(.card-selected):not(.card-inactive) {\r\n    opacity: 0.7;\r\n  }\r\n\r\n  .card:not(.card-selected):not(.card-inactive):hover {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.card:hover:not(.card-selected) {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);\r\n  background: rgba(255, 255, 255, 1);\r\n  border-color: rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n.card-selected:hover {\r\n  transform: scale(1.02) translateY(-2px);\r\n  box-shadow:\r\n    0 18px 60px rgba(102, 126, 234, 0.5),\r\n    0 0 0 4px #667eea;\r\n  background: #d6ecf0;\r\n}\r\n\r\n.card-selected {\r\n  border-color: #667eea;\r\n  background: #e8f4f8;\r\n  box-shadow:\r\n    0 15px 50px rgba(102, 126, 234, 0.4),\r\n    0 0 0 3px #667eea;\r\n  border-width: 4px;\r\n  border-style: solid;\r\n  transform: scale(1.02);\r\n  position: relative;\r\n}\r\n\r\n.card-selected::after {\r\n  content: 'check_circle';\r\n  font-family: 'Material Icons';\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  background: #63c08a;\r\n  color: white;\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n  box-shadow:\r\n    0 3px 12px rgba(46, 204, 113, 0.5),\r\n    0 1px 3px rgba(0, 0, 0, 0.2);\r\n  z-index: 5;\r\n  animation: checkAppear 0.3s ease-out;\r\n  border: 2px solid white;\r\n}\r\n\r\n@keyframes selectedPulse {\r\n\r\n  0%,\r\n  100% {\r\n    opacity: 0.9;\r\n  }\r\n\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes checkAppear {\r\n  0% {\r\n    transform: scale(0);\r\n    opacity: 0;\r\n  }\r\n\r\n  50% {\r\n    transform: scale(1.2);\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.card img {\r\n  width: 60px;\r\n  height: 60px;\r\n  margin-bottom: 0.75rem;\r\n  object-fit: contain;\r\n}\r\n\r\n.card-title {\r\n  font-size: clamp(0.9rem, 2.5vw, 1.1rem);\r\n  font-weight: 700;\r\n  color: #1a1a1a;\r\n  margin-bottom: 0.75rem;\r\n  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.card-description {\r\n  font-size: clamp(0.75rem, 2vw, 0.9rem);\r\n  color: #444;\r\n  line-height: 1.5;\r\n  font-weight: 500;\r\n  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.6);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.card-selected .card-title {\r\n  color: #2d3748;\r\n  font-weight: 800;\r\n  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.card-selected .card-description {\r\n  color: #4a5568;\r\n  font-weight: 600;\r\n  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n/* Botón de inicio */\r\n.start-section {\r\n  flex-shrink: 0;\r\n  padding: 1.5rem 0 2rem;\r\n  background: linear-gradient(to top, rgba(102, 126, 234, 0.05), transparent);\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.start-button {\r\n  width: 100%;\r\n  padding: 1.5rem 1rem;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 1rem;\r\n  font-size: clamp(1.1rem, 3vw, 1.3rem);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n  min-height: 70px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.start-button:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\r\n}\r\n\r\n.start-button:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.start-button::before {\r\n  content: 'play_arrow';\r\n  font-family: 'Material Icons';\r\n  font-size: 1.5em;\r\n}\r\n\r\n/* Fix CRÍTICO para orientación vertical - Forzar reset completo de estilos landscape */\r\n@media (orientation: portrait) {\r\n  .card {\r\n    flex-direction: column !important;\r\n    text-align: center !important;\r\n    gap: 0 !important;\r\n    min-height: 140px !important;\r\n    padding: 1.5rem 1rem !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n  }\r\n\r\n  .card-content {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    width: 100% !important;\r\n    text-align: center !important;\r\n  }\r\n\r\n  .card-title {\r\n    display: block !important;\r\n    visibility: visible !important;\r\n    opacity: 1 !important;\r\n    text-align: center !important;\r\n    margin-bottom: 0.75rem !important;\r\n    font-size: clamp(0.9rem, 2.5vw, 1.1rem) !important;\r\n    font-weight: 700 !important;\r\n    color: #1a1a1a !important;\r\n  }\r\n\r\n  .card-description {\r\n    display: block !important;\r\n    visibility: visible !important;\r\n    opacity: 1 !important;\r\n    text-align: center !important;\r\n    line-height: 1.5 !important;\r\n    font-size: clamp(0.75rem, 2vw, 0.9rem) !important;\r\n    color: #444 !important;\r\n    font-weight: 500 !important;\r\n  }\r\n\r\n  .card img {\r\n    width: 60px !important;\r\n    height: 60px !important;\r\n    margin-bottom: 0.75rem !important;\r\n    object-fit: contain !important;\r\n  }\r\n\r\n  /* Reset específico para móviles en portrait */\r\n  @media (max-width: 480px) {\r\n    .card {\r\n      min-height: 120px !important;\r\n      padding: 1.25rem 0.75rem !important;\r\n    }\r\n\r\n    .card img {\r\n      width: 50px !important;\r\n      height: 50px !important;\r\n      margin-bottom: 0.5rem !important;\r\n    }\r\n\r\n    .card-title {\r\n      margin-bottom: 0.5rem !important;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 360px) {\r\n    .card {\r\n      min-height: 100px !important;\r\n      padding: 1rem 0.5rem !important;\r\n    }\r\n\r\n    .card img {\r\n      width: 40px !important;\r\n      height: 40px !important;\r\n    }\r\n  }\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 480px) {\r\n  .app {\r\n    padding: 1.5rem 0.75rem 0;\r\n    height: 100dvh;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .header {\r\n    padding: 0.75rem;\r\n    margin-bottom: 1.5rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .main-content {\r\n    gap: 1.5rem;\r\n    padding: 0.75rem 0 0;\r\n    flex: 1;\r\n    min-height: 0;\r\n  }\r\n\r\n  .options-section {\r\n    grid-template-columns: 1fr;\r\n    gap: 1rem;\r\n    flex: 1;\r\n    min-height: 0;\r\n    overflow-y: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    scroll-behavior: smooth;\r\n    padding: 0.5rem 0;\r\n  }\r\n\r\n  .card {\r\n    padding: 1.25rem 0.75rem;\r\n    min-height: 120px;\r\n  }\r\n\r\n  .card img {\r\n    width: 50px;\r\n    height: 50px;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n\r\n  .card-title {\r\n    margin-bottom: 0.5rem;\r\n  }\r\n\r\n  .start-section {\r\n    flex-shrink: 0;\r\n    padding: 1rem 0 1.5rem;\r\n    background: linear-gradient(to top, rgba(102, 126, 234, 0.05), transparent);\r\n  }\r\n\r\n  .start-button {\r\n    padding: 1rem 0.75rem;\r\n    min-height: 60px;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .app {\r\n    padding: 1rem 0.5rem 0;\r\n  }\r\n\r\n  .card {\r\n    min-height: 100px;\r\n    padding: 1rem 0.5rem;\r\n  }\r\n\r\n  .card img {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n\r\n  .start-section {\r\n    padding: 0.75rem 0 1rem;\r\n  }\r\n}\r\n\r\n/* Layout mejorado para orientación horizontal - Mantiene estructura familiar */\r\n@media (max-height: 500px) and (orientation: landscape) {\r\n  .app {\r\n    padding: 0.5rem 1rem;\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n    height: 100dvh;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .header {\r\n    padding: 0.5rem 1rem;\r\n    min-height: 40px;\r\n    margin-bottom: 0.75rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .title {\r\n    font-size: clamp(1rem, 3vw, 1.3rem);\r\n  }\r\n\r\n  .about-button {\r\n    width: 36px;\r\n    height: 36px;\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .main-content {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 1rem;\r\n    min-height: 0;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .options-section {\r\n    flex: 1;\r\n    position: relative;\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n    gap: 1rem;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    -webkit-overflow-scrolling: touch;\r\n    scroll-behavior: smooth;\r\n    padding: 0.5rem;\r\n    max-height: 100%;\r\n\r\n    /* Barra de scroll más visible y atractiva */\r\n    scrollbar-width: auto;\r\n    scrollbar-color: rgba(102, 126, 234, 0.8) rgba(255, 255, 255, 0.1);\r\n  }\r\n\r\n  .card {\r\n    min-height: 100px;\r\n    padding: 1rem;\r\n    flex-direction: row;\r\n    text-align: left;\r\n    gap: 1rem;\r\n    transition: all 0.2s ease;\r\n  }\r\n\r\n  .card:hover:not(.card-selected) {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\r\n  }\r\n\r\n  .card img {\r\n    width: 50px;\r\n    height: 50px;\r\n    margin-bottom: 0;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .card-content {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n  }\r\n\r\n  .card-title {\r\n    font-size: 1.1rem;\r\n    margin-bottom: 0.5rem;\r\n    line-height: 1.3;\r\n  }\r\n\r\n  .card-description {\r\n    font-size: 0.9rem;\r\n    line-height: 1.4;\r\n  }\r\n\r\n  .start-section {\r\n    flex-shrink: 0;\r\n    padding: 1rem 0 0.5rem;\r\n  }\r\n\r\n  .start-button {\r\n    width: 100%;\r\n    min-height: 60px;\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n/* Orientación horizontal para móviles pequeños - Layout horizontal compacto */\r\n@media (max-height: 450px) and (orientation: landscape) {\r\n  .app {\r\n    padding: 0.25rem 0.5rem;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .header {\r\n    padding: 0.25rem 0.75rem;\r\n    min-height: 35px;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n\r\n  .title {\r\n    font-size: clamp(0.9rem, 2.5vw, 1.1rem);\r\n  }\r\n\r\n  .about-button {\r\n    width: 30px;\r\n    height: 30px;\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .main-content {\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .options-section {\r\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n    gap: 0.75rem;\r\n    padding: 0.25rem;\r\n  }\r\n\r\n  /* Barra de scroll más prominente en pantallas pequeñas */\r\n  .options-section::-webkit-scrollbar {\r\n    width: 10px;\r\n  }\r\n\r\n  .options-section::-webkit-scrollbar-thumb {\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    border-radius: 5px;\r\n    border: 2px solid rgba(255, 255, 255, 0.1);\r\n  }\r\n\r\n  .card {\r\n    min-height: 80px;\r\n    padding: 0.75rem;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .card img {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n\r\n  .card-title {\r\n    font-size: 1rem;\r\n    line-height: 1.2;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n\r\n  .card-description {\r\n    font-size: 0.8rem;\r\n    line-height: 1.3;\r\n  }\r\n\r\n  .start-section {\r\n    padding: 0.75rem 0 0.5rem;\r\n  }\r\n\r\n  .start-button {\r\n    min-height: 50px;\r\n    font-size: 0.85rem;\r\n    padding: 0.75rem 0.5rem;\r\n  }\r\n}\r\n\r\n/* Estilos para cards inactivas - próximamente */\r\n.card-inactive {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  position: relative;\r\n  background: rgba(220, 220, 220, 0.8) !important;\r\n  border: 3px solid rgba(200, 200, 200, 0.3) !important;\r\n  pointer-events: none;\r\n}\r\n\r\n.card-inactive:hover {\r\n  transform: none;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\r\n  background: rgba(220, 220, 220, 0.8) !important;\r\n}\r\n\r\n.card-inactive .card-title {\r\n  color: #666;\r\n}\r\n\r\n.card-inactive .card-description {\r\n  color: #888;\r\n}\r\n\r\n.card-inactive::after {\r\n  content: var(--coming-soon-text, 'Próximamente');\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  background: #e53e3e;\r\n  color: white;\r\n  padding: 4px 8px;\r\n  border-radius: 12px;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  z-index: 2;\r\n}\r\n\r\n/* Ajustes para modo landscape */\r\n@media (max-height: 500px) and (orientation: landscape) {\r\n  .card-inactive::after {\r\n    top: 4px;\r\n    right: 4px;\r\n    padding: 2px 6px;\r\n    font-size: 0.6rem;\r\n  }\r\n}\r\n\r\n@media (max-height: 450px) and (orientation: landscape) {\r\n  .card-inactive::after {\r\n    top: 2px;\r\n    right: 2px;\r\n    padding: 2px 4px;\r\n    font-size: 0.55rem;\r\n  }\r\n}\r\n\r\n/* Indicador de scroll */\r\n.scroll-indicator {\r\n  position: sticky;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background: linear-gradient(to top, rgba(102, 126, 234, 0.9), transparent);\r\n  padding: 1rem;\r\n  text-align: center;\r\n  z-index: 10;\r\n  opacity: 1;\r\n  transition: opacity 0.3s ease;\r\n  pointer-events: none;\r\n}\r\n\r\n.scroll-indicator.hidden {\r\n  opacity: 0;\r\n}\r\n\r\n.scroll-hint {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  color: white;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.scroll-hint .material-icons {\r\n  font-size: 1.5rem;\r\n  animation: bounce 2s infinite;\r\n}\r\n\r\n@keyframes bounce {\r\n\r\n  0%,\r\n  20%,\r\n  50%,\r\n  80%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n\r\n  40% {\r\n    transform: translateY(-10px);\r\n  }\r\n\r\n  60% {\r\n    transform: translateY(-5px);\r\n  }\r\n}\r\n\r\n/* Ocultar indicador en escritorio */\r\n@media (min-width: 769px) {\r\n  .scroll-indicator {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Ajustar indicador para móviles pequeños */\r\n@media (max-width: 480px) {\r\n  .scroll-indicator {\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  .scroll-hint {\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .scroll-hint .material-icons {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  /* Ajustes para cards seleccionadas en móvil */\r\n  .card-selected::after {\r\n    width: 24px;\r\n    height: 24px;\r\n    font-size: 16px;\r\n    top: 6px;\r\n    right: 6px;\r\n  }\r\n\r\n  .card-selected {\r\n    border-width: 3px;\r\n  }\r\n}\r\n\r\n/* Indicador de scroll específico para landscape - Posicionado dentro del área de scroll */\r\n@media (orientation: landscape) {\r\n  .scroll-indicator {\r\n    position: absolute;\r\n    bottom: 10px;\r\n    right: 10px;\r\n    left: auto;\r\n    top: auto;\r\n    transform: none;\r\n    width: auto;\r\n    background: rgba(102, 126, 234, 0.9);\r\n    border-radius: 20px;\r\n    padding: 0.5rem 0.75rem;\r\n    z-index: 150;\r\n    backdrop-filter: blur(10px);\r\n    -webkit-backdrop-filter: blur(10px);\r\n  }\r\n\r\n  .scroll-hint {\r\n    flex-direction: row;\r\n    writing-mode: horizontal-tb;\r\n    gap: 0.5rem;\r\n    align-items: center;\r\n  }\r\n\r\n  .scroll-hint .material-icons {\r\n    transform: none;\r\n    font-size: 1.1rem;\r\n    animation: bounce 2s infinite;\r\n  }\r\n\r\n  .scroll-hint span {\r\n    font-size: 0.75rem;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n@media (max-height: 450px) and (orientation: landscape) {\r\n  .scroll-indicator {\r\n    bottom: 5px;\r\n    right: 5px;\r\n    padding: 0.25rem 0.5rem;\r\n  }\r\n\r\n  .scroll-hint span {\r\n    font-size: 0.7rem;\r\n  }\r\n\r\n  .scroll-hint .material-icons {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .scroll-indicator {\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .scroll-hint {\r\n    font-size: 0.7rem;\r\n  }\r\n\r\n  .scroll-hint .material-icons {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  /* Ajustes adicionales para pantallas muy pequeñas */\r\n  .card-selected::after {\r\n    width: 20px;\r\n    height: 20px;\r\n    font-size: 14px;\r\n    top: 4px;\r\n    right: 4px;\r\n  }\r\n}\r\n\r\n/* Mejoras adicionales para modo landscape */\r\n@media (orientation: landscape) {\r\n\r\n  /* Hacer más visible el área de scroll */\r\n  .options-section {\r\n    border: 2px solid rgba(102, 126, 234, 0.1);\r\n    border-radius: 8px;\r\n    background: rgba(255, 255, 255, 0.02);\r\n  }\r\n\r\n  /* Hover mejorado para cards en landscape */\r\n  .card:hover {\r\n    background: rgba(255, 255, 255, 1);\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n  }\r\n\r\n  /* Transiciones suaves para el cambio de orientación - Deshabilitadas durante cambios de orientación */\r\n  .app,\r\n  .main-content,\r\n  .options-section,\r\n  .card {\r\n    transition: all 0.3s ease;\r\n  }\r\n\r\n  /* Asegurar que durante los cambios de orientación no haya transiciones que interfieran */\r\n  @media (orientation: portrait) {\r\n\r\n    .card,\r\n    .card-content,\r\n    .card-title,\r\n    .card-description {\r\n      transition: none !important;\r\n    }\r\n  }\r\n}\r\n\r\n/* Estilos para landscape en dispositivos táctiles */\r\n@media (orientation: landscape) and (hover: none) {\r\n  .card {\r\n    /* Hacer las cards más grandes en dispositivos táctiles */\r\n    min-height: 100px;\r\n    padding: 1rem 0.75rem;\r\n  }\r\n\r\n  .card img {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n\r\n  .card-title {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .card-description {\r\n    font-size: 0.85rem;\r\n  }\r\n\r\n  /* Mejorar la experiencia táctil del scroll */\r\n  .options-section {\r\n    -webkit-overflow-scrolling: touch;\r\n    overscroll-behavior: contain;\r\n  }\r\n}\r\n\r\n/* Para pantallas landscape muy anchas (tablets en horizontal) */\r\n@media (min-width: 768px) and (orientation: landscape) {\r\n  .main-content {\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    gap: 2rem;\r\n  }\r\n\r\n  .options-section {\r\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n    gap: 1rem;\r\n  }\r\n\r\n  .card {\r\n    min-height: 110px;\r\n    padding: 1rem;\r\n  }\r\n\r\n  .start-section {\r\n    padding: 1.5rem 0 1rem;\r\n  }\r\n\r\n  .start-button {\r\n    padding: 1.5rem 1rem;\r\n  }\r\n}\r\n\r\n/* Reglas específicas para móviles en landscape */\r\n@media (max-width: 767px) and (orientation: landscape) {\r\n\r\n  /* Asegurar que el contenido no se desborde */\r\n  body {\r\n    overflow-x: hidden;\r\n  }\r\n\r\n  .app {\r\n    min-height: 100dvh;\r\n    max-width: 100vw;\r\n  }\r\n\r\n  /* Optimizar el espacio vertical limitado */\r\n  .header {\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n  }\r\n}\r\n\r\n/* Para pantallas landscape muy bajas (menos de 400px de altura) - Botón horizontal */\r\n@media (max-height: 400px) and (orientation: landscape) {\r\n  .main-content {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .start-section {\r\n    width: auto;\r\n    flex-shrink: 0;\r\n    padding: 0.5rem 0;\r\n  }\r\n\r\n  .start-button {\r\n    width: 100%;\r\n    height: 50px;\r\n    max-height: 50px;\r\n    min-height: 50px;\r\n    flex-direction: row;\r\n    font-size: 0.9rem;\r\n    padding: 0.75rem 1rem;\r\n    gap: 0.5rem;\r\n  }\r\n}\r\n\r\n/* ==========================================\r\n   ESTILOS PARA ENLACES DE DEBUG\r\n   ========================================== */\r\n\r\n.debug-links {\r\n  position: relative;\r\n}\r\n\r\n.debug-dropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.debug-toggle {\r\n  background: linear-gradient(135deg, #ff6b6b, #ee5a24);\r\n  border: none;\r\n  border-radius: 20px;\r\n  color: white;\r\n  padding: 8px 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 2px 8px rgba(238, 90, 36, 0.3);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.debug-toggle:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(238, 90, 36, 0.4);\r\n  background: linear-gradient(135deg, #ff5252, #d84315);\r\n}\r\n\r\n.debug-toggle:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.debug-toggle .material-icons {\r\n  font-size: 16px;\r\n}\r\n\r\n.debug-toggle span {\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n}\r\n\r\n.debug-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  background: rgba(255, 255, 255, 0.98);\r\n  backdrop-filter: blur(20px);\r\n  border-radius: 12px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\r\n  border: 1px solid rgba(255, 255, 255, 0.3);\r\n  min-width: 180px;\r\n  z-index: 1000;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transform: translateY(-10px);\r\n  transition: all 0.3s ease;\r\n  margin-top: 5px;\r\n}\r\n\r\n.debug-menu.show {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  transform: translateY(0);\r\n}\r\n\r\n.debug-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 12px 16px;\r\n  color: #333;\r\n  text-decoration: none;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n  border-radius: 8px;\r\n  margin: 4px;\r\n}\r\n\r\n.debug-link:hover {\r\n  background: linear-gradient(135deg, #667eea, #764ba2);\r\n  color: white;\r\n  transform: translateX(2px);\r\n}\r\n\r\n.debug-link .material-icons {\r\n  font-size: 18px;\r\n  opacity: 0.8;\r\n}\r\n\r\n.debug-link span {\r\n  font-weight: 600;\r\n}\r\n\r\n/* Animación para el icono de debug */\r\n@keyframes debug-pulse {\r\n\r\n  0%,\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n\r\n  50% {\r\n    transform: scale(1.1);\r\n  }\r\n}\r\n\r\n.debug-toggle:hover .material-icons {\r\n  animation: debug-pulse 0.6s ease-in-out;\r\n}\r\n\r\n/* Responsive para debug */\r\n@media (max-width: 480px) {\r\n  .debug-toggle {\r\n    padding: 6px 10px;\r\n    font-size: 11px;\r\n  }\r\n\r\n  .debug-toggle .material-icons {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .debug-toggle span {\r\n    display: none;\r\n    /* Ocultar texto en móviles muy pequeños */\r\n  }\r\n\r\n  .debug-menu {\r\n    min-width: 160px;\r\n    right: -10px;\r\n  }\r\n\r\n  .debug-link {\r\n    padding: 10px 14px;\r\n    font-size: 12px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
